module.exports = __webpack_public_path__ + "img/4.5e541720.png";